import { Board } from '~/components/Shared/Layout/Board/Board';
import { Action } from '~/ui/Actions';
import AddIcon from '~/assets/svg/newSvg/actions/add.svg?react';
import { useTranslation } from 'react-i18next';
import styles from './TournamentConditions.module.scss';
import TournamentConditionsTable from './TournamentConditionsTable/TournamentConditionsTable';
import { useState } from 'react';
import { IFormikCondition } from '../TournamentGeneral';

const TournamentConditions = ({
  tournamentId,
  conditions,
  setFieldValue,
  handleDeleteCondition,
  isEdit,
  status,
}: {
  tournamentId: string;
  conditions: IFormikCondition[];
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  handleDeleteCondition: (id: number) => void;
  isEdit: boolean;
  status: number | undefined;
}) => {
  const { t } = useTranslation();
  const [sort, setSort] = useState({ field: '', direction: '' });
  const [isAdding, setIsAdding] = useState(false);
  return (
    <Board classNames={styles.board}>
      <Action
        variant="success"
        onClick={() => setIsAdding(true)}
        className={styles.action}
        disabled={status === 1 || status === 3}
      >
        <AddIcon />
        {t('add_condition')}
      </Action>
      <div>
        <TournamentConditionsTable
          tournamentId={tournamentId}
          isEdit={isEdit}
          sort={sort}
          setSort={setSort}
          isAdding={isAdding}
          setIsAdding={setIsAdding}
          conditions={conditions}
          setFieldValue={setFieldValue}
          handleDeleteCondition={handleDeleteCondition}
          status={status}
        />
      </div>
    </Board>
  );
};

export default TournamentConditions;
